  <template>
  <div>
   <b-modal style="padding:15px" size="lg" id="EditShipmentGovtModal" ref="modal" title="Edit Shipment (Govt)" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()" @show = "updateModel" @ok= "handleOk" :ok-disabled = "noChange ? true:false">
        <form ref="EditShipmentGovtForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
           
            <div class="col-md-6">
               <b-form-group  label="Shipment Date" label-for="datepicker-2" autocomplete="off">
                  <b-form-datepicker id="datepicker-1" v-model= "ShipmentDate" placeholder="Choose a date" local="en" required :readonly = "IsReadOnly"></b-form-datepicker>
               </b-form-group>
            </div>  
            <div class = "col-md-6">
              <b-form-group  label="Voucher No" label-for="voucherno" autocomplete="off">
                <b-form-input id="voucherno" v-model= "VoucherNo"  required :readonly = "IsReadOnly"></b-form-input>
              </b-form-group>
            </div>
            <div class = "col-md-6">
              <b-form-group  label="Truck No" label-for="truckno" autocomplete="off">
                <b-form-input id="truckno" v-model= "TruckNo"  required  :readonly = "IsReadOnly"></b-form-input>
              </b-form-group>
            </div>
           
            <div class="col-md-6">
              <b-form-group label="Depot" label-for="Depo" autocomplete="off">
                <b-form-select v-model= "SelectedDepoId" :options="deposList" value-field="id" text-field="name" required :disabled = "IsReadOnly">
                  <b-form-select-option :value = null disabled hidden>Select Depot</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
               <div class="col-md-6">
              <b-form-group label="Contractor" label-for="Contractor" autocomplete="off">
                <b-form-select v-model= "SelectedContractorId" :options="contractorsList" value-field="id" text-field="name" required :disabled = "IsReadOnly">
                  <b-form-select-option :value = null disabled hidden>Select Contractor</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
              <div class="col-md-6">
              <b-form-group label="Product" label-for="Product" autocomplete="off">
                <b-form-select v-model= "SelectedFlourId" :options="flourTypes" value-field="id" text-field="name" @change = "getGovtFlourWeights()" required>
                  <b-form-select-option :value = null disabled hidden>Select Type</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
             <div class="col-md-6">
              <b-form-group label="Bag Type" label-for="BagType" autocomplete="off">
                <b-form-select v-model= "SelectedBagId" :options="bags" value-field="flourWeightId" text-field="flourWeight.weight" required>
                  <b-form-select-option :value = null disabled hidden>Select Bag</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
           
             <div class = "col-md-6">
              <b-form-group  label="No Of Sacks" label-for="sacks" autocomplete="off">
                <b-form-input id="sacks" v-model= "NoOfSacks" type = "number"  required></b-form-input>
              </b-form-group>
            </div>
             <div class = "col-md-12">
              <b-form-group  label="" label-for="checkbox" autocomplete="off">
               <b-form-checkbox
                id="checkbox"
                v-model="IsInventoryTransaction"
                name="checkbox-1"
                value: = true
                unchecked-value: = false
              >
               Inventory Transaction
              </b-form-checkbox >
              </b-form-group>
            </div>

            <div class="col" style = "text-align:end">
             <b-button  style = "margin:10px" @click="addToShipmentList()" :disabled= "this.$refs.EditShipmentGovtForm != undefined ? !this.$refs.EditShipmentGovtForm.checkValidity() : true" variant="primary">Add</b-button>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;">
            </div>
          </div>
         <b-card header="Shipment Added Stock" header-tag="header">
            <table class="table table-striped table-borderless cutom-table table-grey table-striped table-sm" 
              style="font-size: 85%;">
                <thead>
                  <tr>
                
                    <th role="columnheader">Product</th>
                    <th role="columnheader">Bag Type </th>
                     <th role="columnheader">Quantity</th>
                    <th role="columnheader">Inventory Transaction</th>
                    <th role="columnheader">Contractor</th>
                     
                    <th role="columnheader" >Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
                  <tr v-if= "shipmentEntries.length<=0" >
                    <td class = "center-td" colspan="6">No Items Added</td>
                  </tr>
                  
                <tr v-else v-for="entry in shipmentEntries" :key=entry.id>
                  <td  role="cell">{{entry.FlourName}}</td>
                  <td  role="cell">{{entry.FlourWeight}}</td>
                  <td  role="cell">{{entry.NoOfSacks}}</td>
                  <td  role="cell">{{entry.IsInventoryTransaction == true  ? 'true':'false'}}</td>

                  <td  role="cell">{{entry.ContName}}</td>
                
            
                  <td>
                    <span @click= "deleteFromList(entry.Id)">
                      <i role="button" style="color:green" class="far fa-trash-alt"></i>
                    </span>       
                  </td>
                </tr>
              </tbody>
            </table>
        </b-card>
          
        </form>
      </b-modal>
      <Toaster ref ="toaster"/>
      </div>
      </template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../../toaster'
export default {
    name: 'EditShipmentGovt',
    mounted()
    {
      this.getGovtFlourTypes();
      this.getDepos();
      this.getContractors();
     
      // console.log(this.$auth.user())
    },
    components:{
      Toaster
    },
    data(){
        return{
          moduleName:'Add Shipment (Govt)',
          noChange:true, //for disabling submit button
          Id:null,   
          ShipmentDate:null,
         
          VoucherNo: null,
          TruckNo : null,
          NoOfSacks: 1,
          SelectedDepoId:null,
          deposList:[],
          SelectedContractorId:null,
          contractorsList:[],
          SelectedFlourId:null,
          flourTypes:[],
          SelectedBagId:null,
          bags:[],
          IsInventoryTransaction:false,
          shipmentEntries:[],
          EntryId:0,
          IsReadOnly:false
         
         
          
		}
  },
  props:
  {
    shipmentToEdit:{
      type:Object,
      default:null
    }
  },
methods:{
 
  deleteFromList(id)
  
  {
    this.noChange = false;
    let index = this.shipmentEntries.findIndex(x=>x.Id == id)

    this.shipmentEntries.splice(index, 1); 
  },
  
  addToShipmentList()
  {
   
    let duplicate = this.shipmentEntries.findIndex(x=>x.FlourTypeId == this.SelectedFlourId 
    && x.IsInventoryTransaction == this.IsInventoryTransaction && x.FlourWeightId == this.SelectedBagId)
    if(duplicate != -1)
    {
      this.$refs.toaster.showToast('Error','danger','Same flour type and weight already exist');
      return;
    }
     if(this.SelectedBagId == null || this.SelectedFlourId == null)
    {
       this.$refs.toaster.showToast('Error','danger','Please select product and bag');
      return;
    }
    let selectedDepo = this.deposList.find(x=>x.id == this.SelectedDepoId);
    let depoName = selectedDepo != null ? selectedDepo.name:"";

    let selectedContractor = this.contractorsList.find(x=>x.id == this.SelectedContractorId);
    let contName = selectedContractor != null ? selectedContractor.name:"";

    let selectedFlour = this.flourTypes.find(x=>x.id == this.SelectedFlourId);
    let flourName = selectedFlour != null ? selectedFlour.name:"";
  console.log(this.SelectedBagId);
  console.log(selectedBag)
    let selectedBag = this.bags.find(x=>x.flourWeightId == this.SelectedBagId);
     console.log(selectedBag)
    console.log(this.bags)
    let bagWeight = selectedBag != null ? selectedBag.flourWeight.weight:"";
    
    
          
    let model = {
     //for backend
      NoOfSacks:parseFloat(this.NoOfSacks),
      FlourTypeId:this.SelectedFlourId,
      FlourWeightId:this.SelectedBagId,
      //for front end
      ContName:contName,
      DepoName:depoName,
      FlourName:flourName,
      FlourWeight:bagWeight,
      IsInventoryTransaction:this.IsInventoryTransaction,
      Id:this.EntryId //for delete purposes from list
      
    }
    this.EntryId++;
 
    this.shipmentEntries.push(model);
    this.IsReadOnly = true;
    this.noChange = false;
    this.SelectedFlourId = null;
    this.SelectedBagId = null;

  },

   getDepos()
   {
    let model = {
            "CompanyId":this.$auth.user().companyId,
            
          }
          axios.post('/depo/getall', model)
          .then(res=>{
          
            this.deposList = res.data.data
          });
   },

    getContractors()
   {
    let model = {
            "CompanyId":this.$auth.user().companyId,
            
          }
          axios.post('/contractor/getall', model)
          .then(res=>{
       
            this.contractorsList = res.data.data
          });
   },

    getGovtFlourTypes()
   {
    let model = {
            "CompanyId":this.$auth.user().companyId,
            "BaseType":1
          }
          axios.post('/flourtype/getall', model)
          .then(res=>{
          
            this.flourTypes = res.data.data
          });
   },

    getGovtFlourWeights()
   {
     this.SelectedBagId = null;
    let model = {
            "CompanyId":this.$auth.user().companyId,
            "FlourTypeId":this.SelectedFlourId
          }
          axios.post('/flourweighttypelink/getall', model)
          .then(res=>{
         
            this.bags = res.data.data
          });
   },

   EditShipmentGovt(){ 
      let model = {
      "ShipmentDate":this.ShipmentDate,
      "VoucherNo":this.VoucherNo,
      "TruckNo":this.TruckNo,
      "DepoId":this.SelectedDepoId,
      "ContractorId":this.SelectedContractorId,
      "ShipmentEntries":this.shipmentEntries,
      "WheatTypeId":this.SelectDepoId,
      "CompanyId":this.$auth.user().companyId,
      "UserId":this.$auth.user().id
      }
    
     axios.post('/shipment/edit', model
      )
      .then(res=>{
      
            if(res.data.status == 1)
            {
            
                 this.$refs.toaster.showToast('Sucess','success','Shipment has been edited successfully')
                this.$bvModal.hide('EditShipmentGovtModal')
                 this.$parent.getShipments();      
     
            }
            else
            {
               this.$refs.toaster.showToast('Error','danger',res.data.msg)      
            }
           
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.EditShipmentGovtForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      resetModal() {
           this.VoucherNo= null,
           this. TruckNo = null,
           this.NoOfSacks= 1,
           this.SelectedDepoId=null,
          // this. deposList=[],
           this.SelectedContractorId=null,
          //  this.contractorsList=[],
           this.SelectedFlourId=null,
          //  this.flourTypes=[],
           this.SelectedBagId=null,
          //  this.bags=[],
           this.IsInventoryTransaction=false,
          this. shipmentEntries=[],
          //  this.EntryId=0,
           this.IsReadOnly=false
      },
       updateModel() {
            this.Id = this.shipmentToEdit.id;
           this.ShipmentDate = this.shipmentToEdit.shipmentDate;
           this.VoucherNo= this.shipmentToEdit.voucherNo;
           this.TruckNo = this.shipmentToEdit.truckNo;
           this.SelectedDepoId=this.shipmentToEdit.depoId;
         
          
           this.SelectedContractorId=this.shipmentToEdit.contractorId;
      
         
          this.IsReadOnly=true
          this.createShipmentEntries(this.shipmentToEdit.flourDetails);
          //  this.EntryId=0,
           this.IsReadOnly=true
      },

      createShipmentEntries(entries)
      {
        var model;
        entries.forEach(element => {
           model = {
        //for backend
          NoOfSacks:parseFloat(element.noOfSacks),
          FlourTypeId:element.flourTypeId,
          FlourWeightId:element.flourWeightId,
          //for front end
          ContName:this.shipmentToEdit.contractor,
          DepoName:this.shipmentToEdit.depo,
          FlourName:element.flourTypeName,
          FlourWeight:element.bagWeight,
          IsInventoryTransaction:element.isInventoryTransaction,
          Id:this.EntryId //for delete purposes from list
          }

            this.EntryId++;
            this.shipmentEntries.push(model);
        });
       
          // console.log(this.shipmentToEdit)
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        // if (!this.checkFormValidity()) {
        //   return
        // } 
        this.EditShipmentGovt()
       
        // this.$nextTick(() => {
        //   //this.$router.go('/phones')
        //   this.$bvModal.hide('EditShipmentGovtdModal')
        
        // })
      },

 

  }
	

}
</script>
